'use client';

import { PopupConfirm } from '@/components/common/PopupConfirm';
import { createContext, useMemo } from 'react';
import type { PopupConfirmContextType } from './usePopupConfirmState';
import { usePopupConfirmState } from './usePopupConfirmState';

export const PopupConfirmContext = createContext<
	PopupConfirmContextType | undefined
>(undefined);

export function PopupConfirmProvider({
	children,
}: { children: React.ReactNode }) {
	const { state, actions } = usePopupConfirmState();

	const contextValue = useMemo(
		() => ({
			...state,
			onConfirm: actions.handleConfirm,
			onCancel: actions.handleCancel,
			show: actions.show,
			hide: actions.hide,
		}),
		[state, actions],
	);

	return (
		<PopupConfirmContext.Provider value={contextValue}>
			{children}
			<PopupConfirm />
		</PopupConfirmContext.Provider>
	);
}
